import { useQuery } from 'react-query';

import { baseErrorHandler } from '../../../queries/baseErrorHandler';
import { $api } from '../../../service/RequestService';
import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
import { IBookingConfig, IBookingHouse } from '../utils/models/booking-integration-model';
import { OneCModel } from '../utils/models/OneCModel';

export function useGetGenerationToken(status: boolean) {
  return useQuery(
    [queryKeys.COMPANY_TOKEN, status],
    async () => {
      const res = await $api.get(`${endPoints.COMPANY_TOKEN}?new=${status}`);

      return res?.data?.data;
    },
    {
      // enabled: !!status,
      onError: baseErrorHandler,
      refetchOnWindowFocus: false,
      refetchInterval: Infinity,
      retry: false
    }
  );
}

export function useGetOneCIntegration() {
  return useQuery<OneCModel>(
    [queryKeys.ONE_C],
    async () => {
      const res = await $api.get(endPoints.ONE_C);

      return res?.data?.data;
    },
    {
      onError: baseErrorHandler,
      refetchOnWindowFocus: false,
      refetchInterval: Infinity,
      retry: false,
      enabled: false
    }
  );
}

export function useGetBookingHouses(enabled: boolean) {
  const initial: { houses: IBookingHouse[] } = {
    houses: []
  };

  const { data = initial, ...arg } = useQuery<{ houses: IBookingHouse[] }>(
    ['marketplace-booking-houses'],
    async () => {
      const { data } = await $api.get('/v1/marketplace-booking-config/house');

      return { houses: data?.data };
    },
    {
      enabled
    }
  );

  return { ...data, ...arg };
}

export function useGetBookingConfig(enabled: boolean) {
  const initial: { config: IBookingConfig } = {
    // @ts-expect-error
    config: {}
  };

  const { data = initial, ...arg } = useQuery<{ config: IBookingConfig }>(
    [queryKeys.MARKETPLACE_BOOKING_CONFIG],
    async () => {
      const { data } = await $api.get('/v1/marketplace-booking-config');

      return { config: data?.data };
    },
    {
      enabled
    }
  );

  return { ...data, ...arg };
}
